import { Instance } from 'mobx-state-tree';
import { DriverProfileDeletedDtoModelBase } from './DriverProfileDeletedDtoModel.base';

/* The TypeScript type of an instance of DriverProfileDeletedDtoModel */
export interface DriverProfileDeletedDtoModelType extends Instance<typeof DriverProfileDeletedDtoModel.Type> {}

/* A graphql query fragment builders for DriverProfileDeletedDtoModel */
export { selectFromDriverProfileDeletedDto, driverProfileDeletedDtoModelPrimitives, DriverProfileDeletedDtoModelSelector } from './DriverProfileDeletedDtoModel.base';

/**
 * DriverProfileDeletedDtoModel
 */
export const DriverProfileDeletedDtoModel = DriverProfileDeletedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
